import { createClient } from '@qub/base-client';

/**
 * The one QubBase client for the whole app. It keeps the user's session in localStorage, refreshes it
 * before it expires, and sends the user's token with every database, storage, function and realtime call.
 */
const url = import.meta.env.VITE_QUBBASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_QUBBASE_ANON_KEY as string | undefined;

export const isConfigured = Boolean(url && anonKey);

export const qubbase = createClient(url || 'http://localhost:4206/p/not-configured', anonKey || 'not-configured');

export const AVATAR_BUCKET = 'avatars';
